module.exports = __webpack_public_path__ + "img/icon-wx.ac504c4c.svg";